import { Button, Form } from "antd";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  emailPattern,
  getLocalStorageItem,
  mobilePattern,
} from "../../../Utils";
import { AEPS3GenerationLink } from "../../../ApiServices/Apifun";
import CommonInput from "../../../Common/CommonInput";
import { setselectedTab } from "../../../Store/B2bslice";

const AEPS3Component = () => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const [btnLoading, setBtnLoading] = useState(false);
  const [transactionType, setTransactionType] = useState("");
  const formref = useRef();
  const memberServices = useSelector((state) => state.B2B.memberServices);

  useEffect(() => {
    dispatch(setselectedTab("1123.1"));
    if (!memberServices.includes("206")) {
      navigate("/not-available");
    }
  }, []);

  const handleAEPS3function = (val) => {
    let formdata = new FormData();
    {
      transactionType !== "MT" && transactionType !== "BW"
        ? formdata.append("amount", val.amount)
        : formdata.append("amount", 0);
    }
    formdata.append("latitude", getLocalStorageItem("latitude"));
    formdata.append("longitude", getLocalStorageItem("longitude"));
    formdata.append("transaction_type", transactionType);
    AEPS3GenerationLink(formdata)
      .then((res) => {
        if (res.status) {
          window.open(res?.data?.checkoutUrl, "_blank");
        }
      })
      .catch((err) => console.log(err));
    // .finally(() => setBtnLoading(false));
  };
  return (
    <>
      <div className="grid grid-cols-1 md:grid-cols-1 place-items-start">
        <div className="prepaid animate-slide-in w-full md:w-1/2 bg-white shadow-normal  rounded-3xl p-5">
          <p className="font-bold text-[15px] mb-2"> AEPS 3</p>
          <Form
            name="form"
            form={form}
            ref={formref}
            onFinishFailed={(err) => console.log(err)}
            onFinish={(val) => handleAEPS3function(val)}
          >
            <Form.Item
              name={`transaction_type`}
              label={"Transaction Type"}
              labelCol={{ span: 24 }}
              rules={[
                {
                  required: true,
                  message: "Select Transaction Type!",
                },
              ]}
            >
              <select
                className="w-full border border-gray-300 rounded-lg  text-sm"
                value={transactionType}
                onChange={(e) => setTransactionType(e.target.value)}
              >
                <option value="">----Select Transaction Type----</option>
                <option value="CW">CASH WITHDRAWAL</option>
                <option value="MT">MINI STATEMENT</option>
                <option value="BW">BALANCE ENQUIRY</option>
                <option value="AD">ADHAAR PAY</option>
                <option value="CD">CASH DEPOSIT</option>
              </select>
            </Form.Item>{" "}
            {transactionType !== "MT" && transactionType !== "BW" ? (
              <Form.Item
                name={`amount`}
                label={"Amount"}
                labelCol={{ span: 24 }}
                rules={[
                  {
                    required: true,
                    message: "Please enter amount",
                  },
                  {
                    whitespace: true,
                    message: "Amount cannot contain only blank spaces",
                  },
                ]}
              >
                <CommonInput placeholder="Enter Amount" name="amount" />
              </Form.Item>
            ) : (
              ""
            )}
            <Button
              loading={btnLoading}
              className="w-full bg-primary border-none mt-4"
              style={{ color: "white" }}
              htmlType="submit"
            >
              Continue
            </Button>
          </Form>
        </div>
      </div>
    </>
  );
};

export default AEPS3Component;